import { useEffect, useState } from 'react';

export const useIsMobileOffice = () => {
  const [isMobileOffice, setIsMobileOffice] = useState(false);

  useEffect(() => {
    const mobileOfficeClassInHtml = 'page-mypages';

    if (document.getElementsByTagName('html')[0]?.classList.contains(mobileOfficeClassInHtml)) {
      setIsMobileOffice(true);
    }
  }, []);

  return isMobileOffice;
};
